import { bankEndPoint } from "./base.config";

export const dnb = {
  getBankBalance: bankEndPoint + '/api/dnb053/getBankBalance',
  getBankTransactionInfo: `${bankEndPoint}/api/dnb053/getBankTransactionInfo`,
  fetchAll: `${bankEndPoint}/api/dnb/fetchAll`,
}